import { z, zv } from '@faceup/validation'
import { DisclosureSubmissionStatus, EvidenceStatus, EvidenceType } from '../enums'
import {
  INVESTIGATION_EVIDENCE_DESCRIPTION_MAX_LENGTH,
  INVESTIGATION_EVIDENCE_NAME_MAX_LENGTH,
  LONG_STRING_MAX_LENGTH,
  STRING_MIN_LENGTH,
} from '../validationConfig'
import { shortStringSchema } from './commonSchema'
import { longTiptapContentSchema } from './tiptapContentSchema'

export const renameInvestigationInputSchema = z.object({
  name: shortStringSchema,
})

export const investigationInvolvedPersonInputSchema = z.object({
  employeeId: z.uuidv7(),
  role: shortStringSchema,
  note: zv.nullableString(z.string().trim().max(LONG_STRING_MAX_LENGTH)),
})

export const investigationEvidenceInputSchema = z.object({
  name: z.string().min(STRING_MIN_LENGTH).max(INVESTIGATION_EVIDENCE_NAME_MAX_LENGTH),
  type: z.enum(EvidenceType),
  status: z.enum(EvidenceStatus).nullable(),
  description: zv.nullableString(z.string().max(INVESTIGATION_EVIDENCE_DESCRIPTION_MAX_LENGTH)),
  employeeId: z.uuid().nullable(),
})

export const updateDisclosureFormInputSchema = z.xor([
  z.object({ name: shortStringSchema }),
  z.object({ description: longTiptapContentSchema.nullable() }),
])

export const updateDisclosureSubmissionInputSchema = z.xor([
  z.object({ status: z.enum(DisclosureSubmissionStatus) }),
  z.object({ assigneeIds: z.array(z.uuidv7()) }),
])
